module.exports = __webpack_public_path__ + "static/img/img_syzb.9102a5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_syzb.png
// module id = z5+U
// module chunks = 0